import { render, staticRenderFns } from "./diys.vue?vue&type=template&id=dddd4656&scoped=true"
import script from "./diys.vue?vue&type=script&lang=js"
export * from "./diys.vue?vue&type=script&lang=js"
import style0 from "./diys.vue?vue&type=style&index=0&id=dddd4656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd4656",
  null
  
)

export default component.exports